import { useTranslation } from "react-i18next";

import { Footer } from "@/components/Layout/BaseLayouts/Footer/Footer";
import { Header } from "@/components/Layout/BaseLayouts/Header";
import { FCC } from "@/types";
import { TranslationKey } from "@/utils/translationKey";

interface Props {
  /** The step's page title, shown in the neutral hero block as its h1. */
  headlineKey: TranslationKey;
}

/**
 * Minimal authenticated layout for mandatory profile steps (initial password,
 * personal data). Shows the welcome branding with a neutral hero headline and
 * the new footer without portal nav.
 */
export const ProfileCompletionPageLayout: FCC<Props> = ({
  children,
  headlineKey,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-background-secondary">
      <Header
        variant="welcome"
        headline={t(headlineKey)}
        headlineIsPageTitle
        heroTheme="neutral"
      />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};
